import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { FACILITIES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/facilities/")({
  component: () => <DeptContentList cfg={FACILITIES} />,
});
